import styled, { css } from "styled-components";

import {
	bettoWalletBonusContainerStyles,
	bettoWalletBonusOptionStyles,
	bettoWalletBonusRadioStyles,
	bettoWalletBonusTextStyles,
	bettoWalletPrimaryButtonStyles,
	bettoWalletSectionTitleStyles,
} from "@pages/profile-v2/betto/shared/bettoWalletPaymentStyles";

import backgroundVertical from "../../assets/paymentLogos/others/background-vertical.png";
import background from "../../assets/paymentLogos/others/background.png";
import failure from "../../assets/paymentLogos/others/failure.png";
import success from "../../assets/paymentLogos/others/success.png";

export const GRID_WRAPPER = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	backdrop-filter: blur(15px);

	@media (min-width: 768px) {
		gap: 15px;
		flex-direction: row;
		flex-wrap: wrap;
		padding: 10px;

		${({ isSub }) =>
			isSub &&
			css`
				padding: 0;
			`}
	}

	@media (min-width: 1024px) {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-template-rows: auto;
		gap: 20px;
		width: 100%;
		padding: 0;
	}

	@media (min-width: 1280px) {
		grid-template-columns: repeat(5, 1fr);
	}

	${({ hasLessBorderRadius }) =>
		hasLessBorderRadius &&
		css`
			border-radius: 10px;
		`}
`;

export const Value = styled.div`
	display: flex;
	color: #eff0f6;
	font-size: 18px;
	font-weight: 300;
	line-height: 20px;

	@media (min-width: 768px) {
		font-size: 24px;
	}

	@media (min-width: 1024px) {
		color: #a0a3bd;
		font-size: 26px;
		font-weight: 300;
		line-height: 36px;
	}
`;

export const MinOrMax = styled.div`
	display: flex;
	color: #eff0f6;
	font-size: 9px;
	font-weight: 400;
	line-height: 14px;
	letter-spacing: 0.25px;

	@media (min-width: 1024px) {
		font-size: 12px;
		line-height: 28px;
		letter-spacing: 0.75px;
		color: #a0a3bd;
	}
`;

export const DepositNameDesktop = styled.div`
	display: none;

	@media (min-width: 1024px) {
		display: flex;
		color: #a0a3bd;
		font-size: 14px;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: 0.75px;
	}
`;
export const DepositNameFeaturesWrapper = styled.div`
	overflow-y: hidden;
	color: #a0a3bd;
	font-size: 10px;
	font-weight: 700;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 16px;
	}

	@media (min-width: 1024px) {
		font-size: 14px;
		font-weight: 600;
		line-height: 16px;
		letter-spacing: 0.3px;
	}
`;

export const DepositButton = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	padding: 0 5px;
	min-width: 40px;
	background: var(--payment-gradient);
	${(props) =>
		props.isHover &&
		css`
			scale: 1.1;
		`}

	@media (min-width: 768px) {
		padding: 0 10px;
		min-width: 50px;
	}

	@media (min-width: 1024px) {
		border-radius: 20px;
		width: 100%;
		height: 40px;
		background: var(--payment-gradient);
	}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			@media (min-width: 1024px) {
				border-radius: 10px;
			}

			svg {
				rect,
				path {
					stroke: #e2e2e2;
				}
			}
		`}
`;

export const MinMaxWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media (min-width: 1024px) {
		min-height: 106px;
		padding: 10px;
		align-items: flex-start;
		gap: 10px;
		align-self: stretch;
		background: var(--payment-modal-center-bg);
		max-height: 106px;
	}
`;

export const NavigationItemWrapper = styled.div`
	align-self: flex-end;
	position: absolute;
	bottom: 0;
	left: 50%;
`;

export const DepositItem = styled.div`
		display: flex;
		height: 90px;
		width: 100%;
		min-height: 90px;
		overflow: hidden;
		border-radius: 20px;
		background: var(--payment-modal-bg);
		.bank-img {
			filter: brightness(0) invert(1);
		}

		@media (min-width: 768px) {
			max-width: calc(50% - 7.5px);
			height: 120px;
			min-height: 120px;
		}

		@media (min-width: 1024px) {
			max-width: 100%;
		}

		@media (min-width: 1024px) {
			flex-direction: column;
			min-height: ${({ hasMinMax }) => (hasMinMax ? "331px" : "225px")};
			height: ${({ hasMinMax }) => (hasMinMax ? "331px" : "225px")};
			justify-content: space-between;

			&:hover {
				background: var(--payment-gradient);

				${MinMaxWrapper} {
					background: var(--main-color-dark);
				}
				${DepositButton} {
					background: var(--main-gradient);
				}

				${DepositNameDesktop},
				${DepositNameFeaturesWrapper},
				${Value},
				${MinOrMax} {
					color: #fff;
				}
			}
		}

		${({ isColorful }) =>
			isColorful &&
			window.TENANT !== "betto" &&
			css`
				@media (min-width: 1024px) {
					&:hover {
						background: linear-gradient(180deg, #44976b 0%, #050512 100%);
						box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
						backdrop-filter: blur(15px);

						${MinMaxWrapper} {
							background: #0e1812;
						}
						${DepositButton} {
							background: var(--main-explosive);
							border-radius: 20px;
						}

						${DepositNameDesktop},
						${DepositNameFeaturesWrapper},
						${Value},
						${MinOrMax} {
							color: #fff;
						}

						${Text} {
							color: #010101;
						}
					}
				}
			`}

		${() =>
			window.HAS_LESS_BORDER_RADIUS &&
			window.TENANT !== "betto" &&
			css`
				border-radius: 10px;
				box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
				backdrop-filter: blur(15px);
				@media (min-width: 1024px) {
					&:hover {
						background: linear-gradient(
							180deg,
							rgba(2, 19, 21, 0.9) 0.62%,
							rgba(12, 49, 55, 0.9) 12.58%,
							rgba(3, 11, 17, 0.9) 100%
						);
						box-shadow: 0px 1px 10px 0px #0b2a2f;
						backdrop-filter: blur(15px);
						border: 1px solid #0b2a30;

						${MinMaxWrapper} {
							background: #0e1812;
						}
						${DepositButton} {
							border-radius: 10px;
							border: 1px solid #fff;
							background: linear-gradient(96deg, #ececfb 13.8%, #eaeaf2 86.14%);
						}

						${DepositNameDesktop},
						${DepositNameFeaturesWrapper},
						${Value},
						${MinOrMax} {
							color: #fff;
						}

						${Text} {
							color: #010101;
						}
					}
				}
			`}
	`,
	DepositMinMax = styled.div`
		display: flex;
		flex-direction: column;

		@media (min-width: 1024px) {
			justify-content: center;
		}
	`,
	DepositNameMobile = styled.div`
		color: #a0a3bd;
		font-size: 9px;
		font-weight: 400;
		line-height: 11px;
		letter-spacing: 0.25px;
		align-self: stretch;
		display: flex;
		max-width: 100px;
		min-width: 90px;
		min-height: max-content;

		@media (min-width: 1024px) {
			display: none;
		}
	`,
	DepositFeature = styled.div`
		font-weight: 700;

		.deposit-feature-items {
			overflow-y: auto;
			overflow-x: hidden;
			max-height: 60px;
			min-width: 200px;

			p {
				margin: 0;
				line-height: 1.5;
			}
		}
	`,
	DepositFeatures = styled.div`
		overflow-y: hidden;
		&:hover {
			overflow-y: scroll;
		}
		&:active {
			overflow-y: scroll;
		}
	`;

export const Text = styled.div`
	display: none;
	@media (min-width: 1024px) {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
	}
`;
export const Icon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	@media (min-width: 1024px) {
		display: none;
	}
`;
export const PaymentLogosGroup = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	flex-wrap: wrap;
`;

export const DepositLogoWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 115px;
	min-width: 115px;
	flex-direction: column;
	height: 90px;
	padding: 10px 5px 10px 10px;

	@media (min-width: 375px) {
		max-width: 130px;
		min-width: 130px;
	}

	@media (min-width: 1024px) {
		max-width: 100%;
		min-width: 100%;
		padding: 0;
	}

	img {
		width: 95px;
		height: auto;

		@media (min-width: 768px) {
			width: 115px;
			height: auto;
		}

		@media (min-width: 1024px) {
			width: 152px;
			height: 50px;
		}
	}

	@media (min-width: 768px) {
		height: 120px;
	}

	@media (min-width: 1024px) {
		height: 85px;
	}
`;
export const ImgWrapper = styled.div`
	display: flex;
	width: 100%;
	padding: 0 15px 0 0;
	height: calc(100% - 22px);
	align-items: center;

	@media (min-width: 1024px) {
		padding: 0;
		justify-content: center;
		height: 85px;
	}
	.no-filter {
		filter: none;
	}
	.w-60 {
		width: 60px;
	}
	.w-pay-badge {
		width: auto;
		max-width: 92px;
		height: auto;
		max-height: 32px;
		object-fit: contain;
	}

	&.pay-badges {
		justify-content: center;
		gap: 6px;

		.bank-img {
			width: auto !important;
			max-width: 72px;
			max-height: 28px;
		}
	}
`;
export const DepositContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	align-items: flex-start;
	border-top-left-radius: 20px;
	border-bottom-left-radius: 20px;
	overflow-y: auto;
	overflow-x: hidden;
	gap: 5px;
	background: var(--payment-page-wrapper-bg);
	padding: 10px;

	@media (min-width: 768px) {
		overflow: unset;
	}

	@media (min-width: 1024px) {
		background: transparent;
		padding: 0;
		gap: 0;
	}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			background: ${window.TENANT === "betto" ? "var(--payment-page-wrapper-bg)" : "#051b1f"};
		`}
`;

export const DepositValueWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 3px;
	flex-wrap: wrap;

	@media (min-width: 1024px) {
		gap: 0;
	}
`;

export const DepositNameWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media (min-width: 1024px) {
		display: flex;
		height: 100px;
		padding: 10px 15px;
		flex-direction: column;
		align-items: flex-start;
		gap: 5px;
		align-self: stretch;
	}
`;

export const PaymentWrapper = styled.div`
		display: flex;
		flex-direction: column;
	`,
	PaymentImg = styled.div`
		background: url(${backgroundVertical}) no-repeat;
		background-size: 428px;
		background-position-x: center;
		background-position-y: bottom;
		grid-area: image;
		@media (min-width: 428px) {
			background-size: 768px;
		}
		@media (min-width: 768px) {
			background-size: cover;
		}
		@media (min-width: 1024px) {
			position: relative;
			&::before {
				content: " ";
				position: absolute;
				top: 0;
				inset-inline-start: 0;
				width: 100%;
				height: 100%;
				background: url(${background}) no-repeat;
				background-size: 150px;
				z-index: 1;
			}
			&::after {
				content: " ";
				position: absolute;
				top: 0;
				inset-inline-start: 0;
				width: 100%;
				height: 100%;
				background: ${() =>
					window.TENANT === "betto"
						? "linear-gradient(to right, #0251b0, #0362d4)"
						: "linear-gradient(to right, #e89200, #eea300)"};
				z-index: 0;
			}
		}
	`,
	Page = styled.div`
		display: flex;
		flex-direction: column;
		gap: 10px;
	`,
	Title = styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
	`,
	BonusContainer = styled.div`
		display: flex;
		flex-direction: column;
		@media (min-width: 1024px) {
			gap: 10px;
			flex-wrap: wrap;
			flex-direction: row;
		}

		${() => window.TENANT === "betto" && bettoWalletBonusContainerStyles}
	`,
	Logo = styled.img`
		width: 120px;
		filter: brightness(0) invert(1);

		&.no-filter {
			filter: none;
		}

		&.w-pay-badge {
			width: auto;
			max-width: 92px;
			max-height: 32px;
			object-fit: contain;
		}
	`,
	FeatureTitleBox = styled.div`
		text-align: end;
		align-items: flex-end;
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex-wrap: wrap;
	`,
	Feature = styled.div`
		color: #eff0f6;
		font-size: 9px;
		font-weight: 400;
		line-height: 11px;
		letter-spacing: 0.25px;

		@media (min-width: 1024px) {
			font-size: 12px;
			line-height: 16px;
			letter-spacing: 0.3px;
		}
	`,
	FeatureBankName = styled.div`
		color: #eff0f6;
		text-align: right;
		font-size: 9px;
		font-weight: 600;
		line-height: 11px;
		letter-spacing: 0.25px;
		display: flex;
		flex-wrap: wrap;
		max-width: 100%;

		@media (min-width: 1024px) {
			font-size: 12px;
			font-weight: 700;
			line-height: 16px;
			letter-spacing: 0.3px;
		}
	`,
	Content = styled.div`
		padding: 0px 0px 100px;
		min-height: 300px;
		height: 100%;
	`,
	ContentTitle = styled.div`
		display: flex;
		justify-content: center;
		border-top: 1px solid #4e4b66;
		color: var(--main-explosive-light);
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		padding: 10px 20px;

		${() => window.TENANT === "betto" && bettoWalletSectionTitleStyles}

		${() =>
			window.HAS_LESS_BORDER_RADIUS &&
			window.TENANT !== "betto" &&
			css`
				background: #0d2a2e;
				margin-bottom: 10px;
				border: none;
				color: #e2e2e2;
				font-size: 10px;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
			`}
	`,
	ContentDescription = styled.div`
		display: flex;
		justify-content: center;
		border-top: 1px solid #4e4b66;
		color: var(--main-explosive-light);
		font-size: 11px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.3px;
		padding: 10px 20px;
	`,
	Navigation = styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		@media (min-width: 1280px) {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			gap: 10px;
			align-items: center;
		}
	`,
	Box = styled.div`
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	`,
	BoxTitle = styled.div`
		text-align: center;
		display: flex;
		min-width: max-content;
		color: #a0a3bd;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.3px;
		margin: 0 10px 10px 0;
	`,
	Stake = styled.div`
		color: #545454;
		background-color: #e9ebef;
		height: 48px;
		line-height: 48px;
		display: flex;
		justify-content: center;
		font-size: 14px;
		font-weight: 600;
		input {
			font-size: 12px;
			width: 100%;
			line-height: 30px;
			padding-inline-start: 8px;
			outline: none;
			border: 0;
			background: none;
		}
	`,
	MaskedInputLabel = styled.label`
		position: absolute;
		top: 50%;
		left: 20px;
		transform: translateY(-50%);
		pointer-events: none;
		transition: 0.2s ease all;
		color: #a0a3bd;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.3px;
		${({ isFocused, hasValue }) =>
			(isFocused || hasValue) &&
			css`
				top: 10px;
				border: none;
				outline: none;
				color: #a0a3bd;
				font-size: 10px !important;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
			`}
		${({ isFocused, hasValue }) =>
			!isFocused &&
			!hasValue &&
			css`
				height: 100%;
				display: flex;
				align-items: center;
			`}
	`,
	MaskedInput = styled.div`
		position: relative;
		display: flex;
		width: 100%;
		border: none;

		input {
			display: flex;
			height: 40px;
			padding: 0 20px;
			justify-content: space-between;
			align-items: center;
			align-self: stretch;
			width: 100%;
			border-radius: 50px;
			background: var(--modal-input-bg);
			border: none;
			outline: none;
			padding-top: 10px;
			color: #f7f7fc;
			font-size: 12px;
			font-weight: 400;
			line-height: 16px;
			letter-spacing: 0.3px;

			&:focus {
				border: 1px solid var(--main-explosive);
				background: var(--input-bg-has-value);
			}

			&:focus + ${MaskedInputLabel} {
				top: 10px;
				border: none;
				outline: none;
				color: #a0a3bd;
				font-size: 10px;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
			}

			${() =>
				window.TENANT === "betto" &&
				css`
					height: 44px;
					border-radius: 8px;
					border: 1px solid #2c313c;
					background: #1f2536;
					color: #e5f0fe;
					font-size: 14px;
					padding-top: 0;

					&:focus {
						border-color: #0362d4;
						background: #1f2536;
					}

					&:focus + ${MaskedInputLabel} {
						top: -10px;
						color: #e5f0fe;
					}
				`}
		}
	`,
	StakeInput = styled.input`
		display: flex;
		height: 40px;
		padding: 0 20px;
		justify-content: space-between;
		align-items: center;
		align-self: stretch;
		width: 100%;
		border-radius: 50px;
		background: var(--modal-input-bg);
		border: none;
		outline: none;
		color: #f7f7fc;
		font-size: 12px;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: 0.3px;
		margin-bottom: 10px;
		&::placeholder {
			color: #a0a3bd;
			font-size: 12px;
		}

		${() =>
			window.TENANT === "betto" &&
			css`
				height: 44px;
				border-radius: 8px;
				border: 1px solid #2c313c;
				background: #1f2536;
				color: #e5f0fe;
				font-size: 14px;

				&:focus {
					border-color: #0362d4;
				}
				&::placeholder {
					color: #7c85a1;
					font-size: 14px;
				}
			`}
	`,
	MinMaxInfo = styled.div`
		color: #a0a3bd;
		text-align: center;
		font-size: 10px;
		font-weight: 400;
		line-height: 12px;
		letter-spacing: 0.25px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
	`,
	BonusText = styled.div`
		color: #a0a3bd;

		${({ isBonusSelected }) =>
			isBonusSelected &&
			css`
				color: #eff0f6;
			`}

		${() => window.TENANT === "betto" && bettoWalletBonusTextStyles}
	`,
	BonusRadioButton = styled.div`
		display: flex;
		width: 25px;
		height: 25px;
		border-radius: 20px;
		border: 1px solid #4e4b66;

		${({ isBonusSelected }) =>
			isBonusSelected &&
			css`
				background: linear-gradient(
					180deg,
					var(--main-color-light) 0%,
					var(--main-color-dark) 100%
				);
				border: none;
				position: relative;

				&::before {
					content: "";
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					width: 10px;
					height: 10px;
					border-radius: 50%;
					background: #252839;
				}
			`}

		${() => window.TENANT === "betto" && bettoWalletBonusRadioStyles}
	`,
	ResultBox = styled.div`
		height: 32px;
		padding: 0 20px;
		background-color: #d9dbe9;
		color: var(--input-bg-has-value);
		font-size: 10px;
		font-weight: 400;
		line-height: 32px;
		display: flex;
		justify-content: space-between;
	`,
	NavigationItem = styled.div`
		opacity: ${(props) =>
			(props.filled && props.filled === true) || props.back || props.close ? "1" : "0.5"};
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 600;
		font-size: 12px;
		text-align: center;
		cursor: pointer;
		border-radius: 20px;
		margin-right: 5px;
		margin-left: 5px;

		svg {
			width: 45px;
			height: 45px;
		}
	`,
	ExternalWrapper = styled.div`
		padding-top: 13px;
		display: grid;
		grid-template-rows: 28px 1fr 60px;
		height: 100%;
		grid-row-gap: 9px;
	`,
	ExternalButton = styled.a`
		display: flex;
		height: 50px;
		justify-content: center;
		padding: 0 10px;
		align-items: center;
		gap: 5px;
		flex: 1 0 0;
		width: 100%;
		border-radius: 25px;
		background: linear-gradient(
			180deg,
			var(--border-color) 0%,
			var(--secondary-border-color) 100%
		);
		color: #f7f7fc;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;

		&:hover {
			color: #f7f7fc !important;
		}

		svg {
			margin: 0 10px;
		}

		${() => window.TENANT === "betto" && bettoWalletPrimaryButtonStyles}
	`,
	BonusWrapper = styled.div`
		display: flex;
		flex-direction: column;
	`,
	BonusContent = styled.div`
		display: flex;
		@media (min-width: 1024px) {
			width: calc(50% - 5px);
		}
	`,
	BonusButton = styled.div`
		display: flex;
		justify-content: flex-start;
		display: flex;
		width: 100%;
		height: 40px;
		align-items: center;
		gap: 5px;
		cursor: pointer;

		@media (min-width: 1024px) {
			width: calc(50% - 5px);
		}

		${() => window.TENANT === "betto" && bettoWalletBonusOptionStyles}
	`,
	BonusDescription = styled.div`
		display: flex;
		flex-direction: column;
		padding: 10px;
		justify-content: flex-start;
		align-items: flex-start;
		gap: 2px;
		flex: 1 0 0;
		border-radius: 15px;
		background: var(--profile-page-wrapper-bg);
		color: #d9dbe9;
		font-size: 10px;
		line-height: 14px;
		letter-spacing: 0.3px;

		* {
			color: #d9dbe9;
		}
	`,
	NoBonusButton = styled.div`
		height: 48px;
		background: ${(props) =>
			props.isBonusSelected ? "linear-gradient(90deg,#FF9D2F,#D85B00)" : "#eff0f6"};
		font-size: 12px;
		line-height: 48px;
		padding-left: 10px;
		color: #000000;
		cursor: pointer;
	`,
	Caution = styled.div`
		font-size: 9px;
		font-style: italic;
		line-height: 1.33;
		color: #3d4045;
	`,
	ExternalDescription = styled.div`
		font-size: 10px;
		font-weight: 700;
		color: #3d4045;
		line-height: normal;
		height: 28px;
	`,
	ResultContent = styled.div`
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	`,
	SuccessImg = styled.div`
		background-image: url(${success});
		background-size: contain;
		background-repeat: no-repeat;
		width: 52px;
		height: 53px;
	`,
	FailureImg = styled.div`
		background-image: url(${failure});
		background-size: contain;
		background-repeat: no-repeat;
		width: 52px;
		height: 53px;
	`,
	ResultText = styled.div`
		height: 112px;
		font-size: 30px;
		font-weight: 700;
		line-height: 1.07;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		text-align: center;
		.detail {
			font-size: 12px;
		}
	`,
	StakeFieldWrapper = styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		height: 100%;

		${() =>
			window.TENANT === "betto" &&
			css`
				gap: 6px;

				.stake-field,
				.min-max-field {
					position: static !important;
					width: 100%;
					text-align: left;
				}
			`}

		${() =>
			window.TENANT !== "betto" &&
			css`
				@media (min-width: 1024px) {
					.stake-field {
						position: relative;
					}
					.min-max-field {
						position: absolute;
						width: max-content;
						right: 45px;
					}
				}
			`}
	`;
